export const DO_QUERY_ACTION = "chat/do-query";
export const RISKCHECK_API_ACTION = "chat/call/riskchecker";
export const GET_GOVT_RULES_API_ACTION = "chat/get/govt-rules";
export const GET_REAL_ACCIDENTS_API_ACTION = "chat/get/real-accidents";
export const GET_IMAGES_DESC_API_ACTION = "chat/get/images-desc";
export const EXPORT_CHAT = "chat/export/chat";
export const MULTI_AI_CHAT_ACTION = "chat/multi-ai-chat";
